import {
	COMPONENT_STATES,
	COMPONENT_TYPE as TYPE,
	DEFAULT_MEDIA_QUERY_PLATFORMS,
	LAYER_TYPE,
	COMPONENT_DISPLAY_NAME,
} from 'common/constants';
import { CSS_PROPS, UNIFORM_PROPS } from 'common/constants/component-props';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Fields/SearchField/SearchField';
import { FieldBBType } from 'client/components/common/BuildingBlocks/Fields/constants';
import { convertPxToVw } from 'utils/helpers';
import type { BuildingBlockFactoryProps } from '../../types';

interface Props extends BuildingBlockFactoryProps {}

export const SEARCH_FIELD = ({ dictionary }: Props = {}) => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.SEARCH_FIELD;

			return {
				_id,
				type,
				uiConfig: {
					layer: LAYER_TYPE.CONTENT,
					editorProps: {
						name: COMPONENT_DISPLAY_NAME[type],
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
					},

					componentProps: {
						[UNIFORM_PROPS.fieldType]: FieldBBType.search,
						[UNIFORM_PROPS.fieldPlaceholder]: dictionary?.SEARCH_FIELD.placeholder.text,
						styles: {
							[COMPONENT_STATES.DEFAULT]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									[CSS_PROPS.field.style.text.phColor]: 'rgba(0, 0, 0, 0.54)',
								},
								[DEFAULT_MEDIA_QUERY_PLATFORMS.MOBILE]: {
									fontSize: convertPxToVw(20, 2, 375),
									height: convertPxToVw(50, 2, 375),
									paddingBottom: convertPxToVw(6, 2, 375),
									paddingLeft: convertPxToVw(6, 2, 375),
									paddingRight: convertPxToVw(18, 2, 375),
									paddingTop: convertPxToVw(6, 2, 375),
									width: convertPxToVw(300, 2, 375),
								},
							},
						},
						other: {},
					},
					nodeProps: {
						id: generateNodeId(_id, type),
					},
				},
				children: [],
			};
		},
	};
};
